import(/* webpackMode: "eager" */ "/opt/build/repo/app/vault/capabilities/page.tsx");
